// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__15f8L","col":"styles_col__2Gu71","fulfillmentStatus":"styles_fulfillmentStatus__3hKAa","emailCol":"styles_emailCol__1RXSj"};